var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Box, Paper, Typography } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
export var getToday = function () {
    var date = new Date();
    var diffMinutes = date.getTimezoneOffset();
    date.setHours(-Math.floor(diffMinutes / 60), -diffMinutes % 60, 0, 0);
    return date;
};
export function daysBefore(date, days) {
    var before = new Date(date);
    before.setDate(before.getDate() - days);
    return before;
}
export var formatDate = function (date) {
    return date.toISOString().substring(0, 4 + 3 + 3);
};
export function getWeekLegend(date) {
    console.log("getWeekLegend: ".concat(date));
    var legend = ["M", "T", "W", "T", "F", "S", "S"];
    var dayOfWeek = date.getDay(); // 0-6 day of week
    return __spreadArray(__spreadArray([], legend.slice(dayOfWeek, 7), true), legend.slice(0, dayOfWeek), true);
}
export var StyledPaper = styled(Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 16px;\n"], ["\n    padding: 16px;\n"])));
export var Separator = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    margin: 16px 0;\n"], ["\n    border-top: 1px solid ", ";\n    margin: 16px 0;\n"])), theme.palette.customGrey.light);
export default function CardChart(_a) {
    var title = _a.title, children = _a.children;
    return (_jsxs(StyledPaper, { children: [_jsx(Typography, __assign({ fontSize: "16px", sx: { marginBottom: 0 }, color: theme.palette.customGrey.main }, { children: title })), _jsx(Separator, {}), children] }));
}
var templateObject_1, templateObject_2;
